

exports.__esModule = true;
exports.$xoGenericErrorPageDirective = undefined;

var _squid = require('squid');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('components/xo-ui-components/src/generic-error/directive');

require('components/xo-return-to-merchant/dist/util');

require('components/xo-ui-components/src/message/directive');

var _customUtil = require('../../../js/lib/customUtil');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoGenericErrorPageDirective = exports.$xoGenericErrorPageDirective = _squid.$Component.extend('$xoGenericErrorPageDirective', {
    tag: 'xo-generic-error-page-directive',
    template: _template2['default'],
    lifecycle: {
        enter: function enter() {
            var xClickParams = _customUtil.customUtil.decodeAndParse(_squid.$meta.xclickParams);
            this.cancelUrl = !xClickParams || !xClickParams.cancel_return ? document.referrer : xClickParams.cancel_return;
        }
    },
    controller: function controller($scope, $rootScope, $logger) {
        var cancelBlockStateChange = $rootScope.$on('$stateChangeStart', function (event) {
            $logger.info('state_change_from_generic_error_blocked');
            event.preventDefault();
        });

        $scope.$on('$destroy', cancelBlockStateChange);
        $('#outerWrapper').addClass('error-page');
    }
});

angular.value("$xoGenericErrorPageDirective", $xoGenericErrorPageDirective);
_squid.$Component;

_squid.$meta;

_customUtil.customUtil;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-error/xo-generic-error/directive.js
// module id = ./pages/xo-error/xo-generic-error/directive.js
// module chunks = 1